import * as storage from './storage';

export function checkTripStarts() {
    let bookingData = storage.get('bookingData');

    if (bookingData) {
        if (bookingData.data?.searchParams?.depDate !== undefined) {
            let depDate = bookingData.data.searchParams.depDate;
            let today = new Date();
            today.setHours(0);
            today.setMinutes(0);
            today.setSeconds(0);

            if (new Date(depDate.split('.').reverse().join('/')).getTime() <= today.getTime()) {
                return true;
            }
        }
    }
    return false;
}

export function checkTripEnds() {
    let bookingData = storage.get('bookingData');

    if (bookingData) {
        if (bookingData.data?.searchParams?.retDate !== undefined) {
            let retDate = bookingData.data.searchParams.retDate;
            let today = new Date();
            today.setHours(0);
            today.setMinutes(0);
            today.setSeconds(0);

            if (new Date(retDate.split('.').reverse().join('/')).getTime() < today.getTime()) {
                return true;
            }
        }
    }
    return false;
}

export function checkCurrentDateIsBefore(date) {
    let today = new Date();
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);

    return new Date(date.split('.').reverse().join('/')).getTime() <= today.getTime();
}
